import auth0 from 'auth0-js';

const webAuth = new auth0.WebAuth({
  domain: 'dev-uqqpvoa5x4776n4j.us.auth0.com',
  clientID: 'xU3fRPAIFSFvSpgrOjVwWcgKgOliCWLz',
  //redirectUri: 'http://localhost:8082/callback', //Dev
  redirectUri: 'https://portal.spotjockeys.com/callback', // The URL to handle Auth0 callbacks
  responseType: 'token id_token',
  scope: 'openid profile email'
});

class AuthService {
  constructor() {
    this.events = {};
  }

  on(event, callback) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(callback);
  }

  emit(event, ...args) {
    if (this.events[event]) {
      this.events[event].forEach(cb => cb(...args));
    }
  }

  login() {
    webAuth.authorize();
  }

  handleAuthentication() {
    return new Promise((resolve, reject) => {
      webAuth.parseHash((err, authResult) => {
        if (authResult && authResult.accessToken && authResult.idToken) {
          this.setSession(authResult);
          resolve(authResult);
        } else if (err) {
          console.log(err);
          reject(err);
        } else {
             // No auth result and no error?
             resolve();
        }
      });
    });
  }

  setSession(authResult) {
    const expiresAt = JSON.stringify((authResult.expiresIn * 1000) + new Date().getTime());
    localStorage.setItem('access_token', authResult.accessToken);
    localStorage.setItem('id_token', authResult.idToken);
    localStorage.setItem('expires_at', expiresAt);
    this.emit('authenticated');
    console.log('User successfully logged in and expires at', new Date(parseInt(expiresAt)));
  }

  logout() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('expires_at');
    webAuth.logout({
      returnTo: 'https://portal.spotjockeys.com',
      clientID: 'xU3fRPAIFSFvSpgrOjVwWcgKgOliCWLz',
    });
  }

  isAuthenticated() {
    const expiresAt = JSON.parse(localStorage.getItem('expires_at'));
    return new Date().getTime() < expiresAt;
  }

  getExpiresAt() {
    const expiresAt = JSON.parse(localStorage.getItem('expires_at'));
    return expiresAt || 0;
  }

  renewSession() {
    return new Promise((resolve, reject) => {
      webAuth.checkSession({}, (err, authResult) => {
        if (authResult && authResult.accessToken && authResult.idToken) {
          this.setSession(authResult);
          resolve(authResult);
        } else if (err) {
          console.log(err);
          this.logout();
          reject(err);
        }
      });
    });
  }

  getProfile(cb) {
    const accessToken = localStorage.getItem('access_token');
    if (!accessToken) {
      cb(new Error('Access Token must exist to fetch profile'));
    }
    webAuth.client.userInfo(accessToken, (err, profile) => {
      cb(err, profile);
    });
  }
}

export default new AuthService();
